import { StandardModal } from 'components/common/Modal/StandardModal';
import { FunctionComponent } from 'react';
import { VStack } from '@montel/montelpro-shared-components-v2';
import { LabelAndValue } from 'components/common/LabelAndValue/LabelAndValue';
import { PermissionSetRows } from './PermissionSetRows';
import { SubscriptionUpdateEventData } from './interfaces';
import { DeltaRow } from './DeltaRow';
import { CompanyDeltaRow } from './CompanyDeltaRow';

export const SubscriptionUpdatedDetailsModal: FunctionComponent<{
	isOpen: boolean;
	onClose: () => void;
	eventData: SubscriptionUpdateEventData | null;
}> = ({ isOpen, onClose, eventData }) => {
	if (!eventData) {
		return null;
	}

	return (
		<StandardModal isOpen={isOpen} onClose={onClose} header="Changes">
			<VStack fullWidth gap="sm">
				<DeltaRow label="Status" delta={eventData.status} />
				<DeltaRow label="Seats" delta={eventData.seats} />
				<DeltaRow label="Start Date" delta={eventData.startDate} />
				<DeltaRow label="End Date" delta={eventData.endDate} />
				<DeltaRow label="Type" delta={eventData.type} />
				<DeltaRow label="Description" delta={eventData.description} />
				<CompanyDeltaRow change={eventData.company} />

				{eventData.applicationPermissions && (
					<LabelAndValue
						label="Application Permissions"
						value={
							<PermissionSetRows
								permissions={eventData.applicationPermissions}
							/>
						}
					/>
				)}
			</VStack>
		</StandardModal>
	);
};
